export const LANG_EN_NAME = 'en';

export const LANG_EN_TRANS = {
'account.search.SearchButton':'Search',
'account.search.ResetButton':'Reset',
'account.search.ContinueButton':'Continue',
'account.search.CancelButton':'Cancel',
'account.search.BackButton':'Back',
'account.search.SaveButton':'Save',
'account.HiddenSearchAccountButton':'Open Search',
'account.HiddenAddAccountButton':'Open Search',
'account.account-search.modalHeadLabel':'Add New Subscription',
'account.account-search.SearchResultLabel':'Subscription Name',
'account.subscription-info.LabelHeading':'Client Information',
'account.subscription-info.LabelSubscriptionName':'Subscription Name',
'account.subscription-info.LabelDefaultCurrency':'Default Currency',
'account.subscription-info.LabelPrimaryRegion':'Primary Region',
'account.subscription-info.LabelDescription':'Description',
'account.subscription-info.LabelSubscriptionOwnerUsername':'Subscription Owner Username',
'account.subscription-info.LabelSubscriptionOwnerEmail':'Subscription Owner Email',
'account.subscription-info.LabelPrimaryPartyID':'Primary Party ID',
'account.subscription-info.LabelPrimaryPartyName':'Primary Party Name',
'account.account-info.LabelHeading':'Energy Losses Information',
'account.account-info.LabelClientName':'Client Name',
'account.account-info.LabelSubscriptionStartDate':'Subscription Start Date',
'account.account-info.LabelSubscriptionEndDate':'Subscription End Date',
'account.account-info.LabelInvoiceStatus':'Invoice Status',
'account.account-info.LabelSubscriptionStatus':'Subscription Status',
'account.account-info.LabelSupressSubscriptionNotification':'Supress Subscription Notification',
'account.account-info.LabelKeyContactName':'Key Contact Name',
'account.account-info.LabelCompanyLegalName':'Company Legal Name',
'account.account-info.LabelEmail':'Email',
'account.account-info.LabelAddress':'Address',
'account.account-info.LabelCity':'City',
'account.account-info.LabelCountry':'Country',
'account.account-info.LabelRequiredField':'Required field',
'account.account-user.LabelHead':'User Maintenance',
'account.account-user.ActivateClientSubscriptionButton':'Activate Client Subscription',
'account.account-user.add-user.LabelHead':'Add New User',
'account.account-user.add-user.LabelAddUsers':'Add Users',
'account.account-user.add-user.LabelUserProfile':'User Profile',
'account.account-user.add-user.LabelSearchProfile':'Search Profile',
'account.account-user.add-user.LabelDisplayName':'Display Name',
'account.account-user.add-user.LabelEmail':'Email',
'account.account-user.add-user.AlertNewUser1':'Success! User',
'account.account-user.add-user.AlertNewUser2':'successfully added.',
'account.account-user.add-user.Modal.LabelHead':'Add User',
'account.account-user.add-user.Modal.LabelUserProfile':'User Profile',
'account.account-user.add-user.Modal.LabelEmail':'Email',
'account.account-user.add-user.Modal.LabelName':'Name',
'account.account-user.add-user.Modal.LabelCity':'City',
'account.account-user.add-user.Modal.LabelCountry':'Country',
'account.account-user.add-user.Modal.LabelInternalUser':'Internal User',
'account.account-user.add-user.Modal.LabelExternalUser':'External User',
'account.account-user.add-user.Modal.LabelisActive':'isActive',
'account.account-user.edit-user.LabelHead':'Existing Users',
'account.account-user.edit-user.LabelUserProfile':'User Profile',
'account.account-user.edit-user.LabelSearchUsers':'Search Users',
'account.account-user.edit-user.LabelUserType':'User Type',
'account.account-user.edit-user.LabelDisplayName':'Display Name',
'account.account-user.edit-user.LabelEmail':'Email',
'account.account-user.edit-user.LabelActive':'Active',
'account.account-user.add-user.AlertEditUser':'Success! User updated successfully',
'account.account-user.edit-user.Modal.LabelHead':'Edit User',
'account.account-user.edit-user.Modal.LabelUserProfile':'User Profile',
'account.account-user.edit-user.Modal.LabelEmail':'Email',
'account.account-user.edit-user.Modal.LabelName':'Name',
'account.account-user.edit-user.Modal.LabelCity':'City',
'account.account-user.edit-user.Modal.LabelCountry':'Country',
'account.account-user.edit-user.Modal.LabelInternalUser':'Internal User',
'account.account-user.edit-user.Modal.LabelExternalUser':'External User',
'account.account-user.edit-user.Modal.LabelisActive':'isActive',
};


// WEBPACK FOOTER //
// ./src/app/shared/translate/lang-en.ts